"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManyError = void 0;
class ManyError extends Error {
    constructor(error) {
        // Error messages replace `{NAME}` with error["2"].name
        const { "0": code, "1": message, "2": fields } = error;
        if (message === undefined) {
            super(`ManyError(${code || 0}) message=${JSON.stringify(message)} fields=${JSON.stringify(fields)}`);
        }
        else {
            const re = /\{\{|\}\}|\{[^\}\s]*\}/g;
            super(message.replace(re, (fieldName) => {
                switch (fieldName) {
                    case "{{":
                        return "{";
                    case "}}":
                        return "}";
                    default:
                        return (fields && fields[fieldName.slice(1, -1)]) || "";
                }
            }));
        }
        this.code = code || 0;
        this.fields = fields || {};
    }
}
exports.ManyError = ManyError;
